<template>
  <form>
    <div class="row mb-2">
      <div class="col-sm-12">
        <div v-if="isImport">
          <div class="row mt-2">
            <label for="trader" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.trader") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" field="trader" form="requisitesForm">
                <TraderMultiselect id="trader" :class="parentProps.class" :small="false"  v-model="form.trader">
                </TraderMultiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2">
            <label for="mappingRowNum" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.row_number") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" field="mappingRowNum" form="requisitesForm">
                <input v-model="form.mappingRowNum"
                       :class="parentProps.class" type="text" class="form-control " id="mappingRowNum">
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="!fileAttachment">
            <div class="col-sm-12">
              <div style="cursor: pointer; border:1px dashed" v-bind="dropzone.getRootProps()" class="payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center">
                <input v-bind="dropzone.getInputProps()" />
                <p class="p-0 m-0">{{ helper.trans('labels.payout_upload_files')}}</p>
              </div>
            </div>
          </div>
          <div v-if="fileAttachment" class="row mt-2">
            <div class="col-sm-12">
              <i class="fa fa-paperclip"></i> <span class="me-2">{{ fileAttachment?.file.name}}</span>
              <a href="#" @click.prevent="state.fileAttachment = null">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>

        </div>

        <div class="row mt-2">
          <label for="isActive" class="col-sm-4 col-form-label  text-capitalize-first">
            {{ form.isActive ? helper.trans('requisites.active') : helper.trans('requisites.inactive') }}
          </label>
          <div class="col-sm-8 form-check form-switch d-flex align-items-center">
            <input v-model="form.isActive" id="isActive" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch"  >
          </div>
        </div>

        <div class="row mt-2" v-if="!isAdmin && !form.id && store.getters.getAppData?.fraudexEnabled">
          <label for="isWhiteTriangle" class="col-sm-4 col-form-label text-capitalize-first">
            {{ helper.trans('labels.white_triangle') }}
          </label>
          <div class="col-sm-8 form-check form-switch d-flex align-items-center">
            <input v-model="form.isWhiteTriangle" id="isWhiteTriangle" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch"  >
          </div>
        </div>

        <div class="row mt-2">
          <label for="currency" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.currency") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="currency" form="requisitesForm">
            <Multiselect id="currency"
                         class=""
                         v-model="form.currency"
                         :options="store.getters['currencyMethods/currencies']"
                         :custom-label="(opt) => `${opt}`"
                         :multiple="false"
                         :class="parentProps.class"
                         select-label="Select"
                         placeholder=""
            >
            </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="paymentOption" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payment_method") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="paymentOption" form="requisitesForm">
              <Multiselect id="paymentOption"
                           :disabled="!form.currency"
                           class=""
                           v-model="form.paymentOption"
                           :options="store.getters['currencyMethods/options'](form.currency)"
                           :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           placeholder=""
              >
                <template #option="props">
                  <div class="d-flex flex-row align-items-center gap-2">
                    <span>{{ helper.trans('payment_options.' + props.option) }}</span>
                  </div>
                </template>

                <template #singleLabel="props">
                  <div class="d-flex flex-row align-items-center gap-1">
                    <span>{{ helper.trans('payment_options.' + props.option) }}</span>
                  </div>
                </template>

              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="[PaymentOption.CROSS_BORDER, PaymentOption.MOBILE_TOP_UP, PaymentOption.SBP_QR, PaymentOption.CARD_ACQUIRING_REDIRECT].includes(form.paymentOption)">
          <label for="crossBorderCurrency" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.crossBorderCurrency") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="crossBorderCurrency" form="requisitesForm">
              <Multiselect id="currency"
                           class=""
                           v-model="form.crossBorderCurrency"
                           :options="store.getters['currencyMethods/crossBorderCurrencies']"
                           :custom-label="(opt) => `${opt}`"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="method" class="col-sm-4 col-form-label text-capitalize-first"></label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="method" form="requisitesForm">
            <Multiselect id="method"
                         :disabled="!form.paymentOption || !paymentOptionCurrency"
                         class=""
                         v-model="form.method"
                         :options="store.getters['currencyMethods/methods'](paymentOptionCurrency, ![PaymentOption.CROSS_BORDER, PaymentOption.MOBILE_TOP_UP].includes(form.paymentOption) ? form.paymentOption:  (paymentOptionCurrency === 'RUB' ? form.paymentOption : null))"
                         :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                         :multiple="false"
                         :class="parentProps.class"
                         select-label="Select"
                         placeholder=""
            >
              <template #option="props">
                <div class="d-flex flex-row align-items-center gap-2">
                  <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                  <span>{{ helper.trans('pay_methods.' + props.option) }}</span>
                </div>
              </template>

              <template #singleLabel="props">
                <div class="d-flex flex-row align-items-center gap-1">
                  <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                  <span>{{ helper.trans('pay_methods.' + props.option) }}</span>
                </div>
              </template>

            </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="form.currency && form.paymentOption && form.method && store.getters['currencyMethods/paymentSystems'](form.currency, form.paymentOption).length > 0">
          <label for="paymentSystem" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payment_system") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="paymentSystem" form="paymentSystem">
              <Multiselect id="paymentSystem"
                           class=""
                           v-model="form.paymentSystem"
                           :options="store.getters['currencyMethods/paymentSystems'](form.currency, form.paymentOption)"
                           :custom-label="(opt) => helper.trans(`payment_systems.${opt}`)"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           placeholder=""
              >
                <template #option="props">
                  <div class="d-flex flex-row align-items-center gap-2">
                    <span>{{ helper.trans('payment_systems.' + props.option) }}</span>
                  </div>
                </template>

                <template #singleLabel="props">
                  <div class="d-flex flex-row align-items-center gap-1">
                    <span>{{ helper.trans('payment_systems.' + props.option) }}</span>
                  </div>
                </template>

              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="!isImport && form.paymentOption !== PaymentOption.VIET_QR && form.paymentOption !== PaymentOption.IND_QR && form.paymentOption !== PaymentOption.BR_QR && form.paymentOption !== PaymentOption.MANUAL_SBP_QR">
          <label for="requisites" class="col-sm-4 col-form-label text-capitalize-first">{{ requisiteFieldLabel }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="requisites" form="requisitesForm">
            <input v-model="form.requisites"
                   v-maska
                   :placeholder="requisitesMaskaPlaceholder"
                   :class="parentProps.class"
                   :data-maska="requisitesMaskaOptions.pattern"
                   :data-maska-tokens="requisitesMaskaOptions.tokens"
                   type="text" class="form-control " id="requisites">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-1" v-if="form.paymentOption === PaymentOption.SBP_QR && form.method === PaymentMethod.qr_manager">
          <div class="col-sm-4"></div>
          <div class="col-sm-8">
            <small class="text-muted">{{ helper.trans('qr_manager.requisites_hint') }}</small>
          </div>
        </div>

        <div class="row mt-2" v-if="!isImport && isHolderNameVisible">
          <label for="holderName" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.holder_name") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="holderName" form="requisitesForm">
            <input v-model="form.holderName" :class="parentProps.class" type="text" class="form-control " id="holderName">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="!isImport && form.paymentOption === PaymentOption.CROSS_BORDER">
          <label for="crossBorderSwift" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.raw_field.swift") }} <small class="text-muted fw-normal">({{ helper.trans('labels.optional_field') }})</small></label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="raw.swift" form="requisitesForm">
            <input v-model="form.raw.swift" :class="parentProps.class" type="text" class="form-control " id="crossBorderSwift">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="!isImport && isAccountNumberVisible">
          <label for="accountNumber" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.account_number") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="accountNumber" form="requisitesForm">
              <input v-model="form.accountNumber" :class="parentProps.class" type="text" class="form-control" id="accountNumber">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-1 mb-1" v-if="form.paymentOption === PaymentOption.SBP_QR && form.method === PaymentMethod.qr_manager && additionalFields.length > 0">
          <div class="col-sm-4"></div>
          <div class="col-sm-8">
            <small class="text-muted">{{ helper.trans('qr_manager.p2c_credentials_intro') }}</small>
          </div>
        </div>

        <div class="row mt-2" v-for="field in additionalFields">
          <label :for="`additional_field_${field.name}`" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans(`labels.additional_field.${field.name}`) }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :field="`additional_field_${field.name}`" form="requisitesForm">
              <input v-if="field.type === 'input'" v-model="form.p2cConfig[field.name]" :class="parentProps.class" type="text" class="form-control" :id="`additional_field_${field.name}`">
              <textarea rows="5" v-if="field.type === 'textarea'" v-model="form.p2cConfig[field.name]" :class="parentProps.class" type="text" class="form-control" :id="`additional_field_${field.name}`"></textarea>
              <Multiselect v-if="field.type === 'dropdown'"
                           :class="parentProps.class"
                           :id="`additional_field_${field.name}`"
                           v-model="form.p2cConfig[field.name]"
                           :options="field.values"
                           :custom-label="(opt) => field.customLabel(opt)"
                           :multiple="false"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="!isImport && form.paymentOption === PaymentOption.IND_QR">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.qris_type") }}</label>
          <div class="col-sm-8 d-flex align-items-center gap-3">
            <div class="form-check">
              <input v-model="form.qrisIsStatic" :value="false" class="form-check-input" type="radio" name="qrisIsStatic" id="qrisDynamicAdmin">
              <label class="form-check-label" for="qrisDynamicAdmin">{{ helper.trans('labels.qris_dynamic') }}</label>
            </div>
            <div class="form-check">
              <input v-model="form.qrisIsStatic" :value="true" class="form-check-input" type="radio" name="qrisIsStatic" id="qrisStaticAdmin">
              <label class="form-check-label" for="qrisStaticAdmin">{{ helper.trans('labels.qris_static') }}</label>
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="!isImport && form.paymentOption === PaymentOption.BR_QR">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pix_type") }}</label>
          <div class="col-sm-8 d-flex align-items-center gap-3">
            <div class="form-check">
              <input :checked="form.pixIsStatic !== true" class="form-check-input" type="radio" name="pixIsStatic" id="pixDynamicAdmin" @change="form.pixIsStatic = false">
              <label class="form-check-label" for="pixDynamicAdmin">{{ helper.trans('labels.pix_dynamic') }}</label>
            </div>
            <div class="form-check">
              <input :checked="form.pixIsStatic === true" class="form-check-input" type="radio" name="pixIsStatic" id="pixStaticAdmin" @change="form.pixIsStatic = true">
              <label class="form-check-label" for="pixStaticAdmin">{{ helper.trans('labels.pix_static') }}</label>
            </div>
          </div>
        </div>

        <div class="row mt-2" v-for="field in rawFields" :key="field.name">
          <label :for="`raw_field_${field.name}`" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans(`labels.raw_field.${field.name}`, {}, field.name) }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :field="`raw_field_${field.name}`" form="requisitesForm">
              <input :readonly="field.readonly ?? false" v-if="field.type === 'input'" v-model="form.raw[field.name]" :class="parentProps.class" type="text" class="form-control" :id="`raw_field_${field.name}`">
              <textarea :readonly="field.readonly ?? false" rows="5" v-if="field.type === 'textarea'" v-model="form.raw[field.name]" :class="parentProps.class" type="text" class="form-control" :id="`raw_field_${field.name}`"></textarea>
              <DropzoneInput v-if="field.type === 'dropzone'" :options="{accept:['.jpg', '.png', '.jpeg'], multiple: false, maxFiles: 1}" @change="field.dropzone?.onChange" :label="field.label"></DropzoneInput>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="group" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.req_group") }}</label>
          <div class="col-sm-8">
            <Multiselect id="group"
                         class=""
                         v-model="form.groupId"
                         :options="store.getters['reqGroups/ids']"
                         :custom-label="(opt) => store.getters['reqGroups/get'](opt)?.name"
                         :multiple="false"
                         select-label="Select"
                         placeholder=""
            >
            </Multiselect>
          </div>
        </div>


        <div class="row mt-4">
          <label for="device" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.device") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="deviceId" form="requisitesForm">
              <DevicesMultiselect
                id="device"
                :small="false"
                :class="parentProps.class"
                ref="deviceMultiselect"
                :multiple="false"
                :trader-ids="form.trader ? [form.trader?.id] : []"
                v-model="form.deviceId"
              />
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label class="col-sm-12 col-form-label  text-center text-capitalize-first">{{ helper.trans("labels.limits") }}</label>
        </div>
        <div class="row align-items-start">
          <label for="minPayInDealSum" class="col-sm-3 col-form-label text-capitalize-first pe-2 text-end">{{ helper.trans("labels.min_pay_in_deal_sum") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="minPayInDealSum" form="requisitesForm">
              <input v-model="form.minPayInDealSum"
                     v-maska
                     :readonly="!form.payInDealSumsEditable"
                     :disabled="isMinSumFieldDisabledByTraderLimit"
                     :class="[parentProps.class, {'bg-light': isMinSumFieldDisabledByTraderLimit}]"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" class="form-control" id="minPayInDealSum">
            </FormInputWrapper>
            <div v-if="store.getters.getAppData?.payInMultiplesEnabled" class="mt-2">
              <label for="multiplesOfValue" class="form-label text-capitalize-first mb-1">{{ helper.trans("labels.multiples_of_value") }}</label>
              <FormInputWrapper v-slot="parentProps" field="multiplesOfValue" form="requisitesForm">
                <input v-model="form.multiplesOfValue"
                       v-maska
                       :class="parentProps.class"
                       data-maska="9 99#"
                       data-maska-tokens="9:[0-9]:repeated"
                       data-maska-reversed
                       type="text" class="form-control" id="multiplesOfValue">
              </FormInputWrapper>
            </div>
          </div>
          <label for="maxPayInDealSum" class="col-sm-3 col-form-label text-capitalize-first  pe-2 text-end">{{ helper.trans("labels.max_pay_in_deal_sum") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="maxPayInDealSum" form="requisitesForm">
              <input v-model="form.maxPayInDealSum"
                     v-maska
                     :readonly="!form.payInDealSumsEditable"
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" class="form-control " id="maxPayInDealSum">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="dayTradesSumLimit" class="col-sm-3 col-form-label text-capitalize-first pe-2 text-end">{{ helper.trans("labels.daily_sum") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="dayTradesSumLimit" form="requisitesForm">
            <input v-model="form.dayTradesSumLimit"
                   v-maska
                   :class="parentProps.class"
                   data-maska="9 99#"
                   data-maska-tokens="9:[0-9]:repeated"
                   data-maska-reversed
                   type="text" class="form-control " id="dayTradesSumLimit">
            </FormInputWrapper>
          </div>
          <label for="monthTradesSumLimit" class="col-sm-3 col-form-label text-capitalize-first  pe-2 text-end">{{ helper.trans("labels.monthly_sum") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="monthTradesSumLimit" form="requisitesForm">
            <input v-model="form.monthTradesSumLimit"
                   v-maska
                   :class="parentProps.class"
                   data-maska="9 99#"
                   data-maska-tokens="9:[0-9]:repeated"
                   data-maska-reversed
                   type="text" class="form-control " id="monthTradesSumLimit">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="dayTradesCountLimit" class="col-sm-3 col-form-label  pe-2 text-capitalize-first text-end">{{ helper.trans("labels.daily_qty") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="dayTradesCountLimit" form="requisitesForm">
              <input v-model="form.dayTradesCountLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="dayTradesCountLimit">
            </FormInputWrapper>
          </div>
          <label for="monthTradesCountLimit" class="col-sm-3 col-form-label  pe-2 text-capitalize-first text-end">{{ helper.trans("labels.monthly_qty") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="monthTradesCountLimit" form="requisitesForm">
              <input v-model="form.monthTradesCountLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="monthTradesCountLimit">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="store.getters.getAppData?.requisitesAllDealsCountLimitsEnabled">
          <label for="dayTradesAllCountLimit" class="col-sm-3 col-form-label  pe-2 text-capitalize-first text-end">{{ helper.trans("labels.daily_qty_all_deals") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="dayTradesAllCountLimit" form="requisitesForm">
              <input v-model="form.dayTradesAllCountLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="dayTradesAllCountLimit">
            </FormInputWrapper>
          </div>
          <label for="monthTradesAllCountLimit" class="col-sm-3 col-form-label  pe-2 text-capitalize-first text-end">{{ helper.trans("labels.monthly_qty_all_deals") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="monthTradesAllCountLimit" form="requisitesForm">
              <input v-model="form.monthTradesAllCountLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="monthTradesAllCountLimit">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="store.getters.getAppData?.requisitesTotalLimitEnabled">
          <label for="totalTradesSumLimit" class="col-sm-3 col-form-label text-capitalize-first pe-2 text-end">{{ helper.trans("labels.total_sum") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="totalTradesSumLimit" form="requisitesForm">
              <input v-model="form.totalTradesSumLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" class="form-control " id="totalTradesSumLimit">
            </FormInputWrapper>
          </div>
          <label for="totalTradesCountLimit" class="col-sm-3 col-form-label pe-2 text-capitalize-first text-end">{{ helper.trans("labels.total_qty") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="totalTradesCountLimit" form="requisitesForm">
              <input v-model="form.totalTradesCountLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="totalTradesCountLimit">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2 requisites__block--switcher" v-if="store.getters.getAppData?.requisitesTotalLimitEnabled">
          <label class="col-sm-3 col-form-label text-capitalize-first pe-2 text-end">{{ helper.trans('labels.manual_reset_enabled') }}</label>
          <div class="col-sm-3 d-flex align-items-center">
            <label class="switch">
              <input type="checkbox" v-model="form.manualResetEnabled">
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <div class="row mt-2" v-if="form.maxReuseCountEnable">
          <label for="maxReuseCount" class="col-sm-3 col-form-label  pe-2 text-capitalize-first text-end">{{ helper.trans("labels.maxReuseCount") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="maxReuseCount" form="requisitesForm">
              <input v-model="form.maxReuseCount"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="maxReuseCount">
            </FormInputWrapper>
          </div>
          <label for="reuseDaysCount" class="col-sm-3 col-form-label  pe-2 text-capitalize-first text-end">{{ helper.trans("labels.reuseDaysCount") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="reuseDaysCount" form="requisitesForm">
              <input v-model="form.reuseDaysCount"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="reuseDaysCount">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="form.maxReuseCountEnable">
          <label for="reusablePaymentsCountLimit" class="col-sm-3 col-form-label pe-2 text-capitalize-first text-end">{{ helper.trans("labels.reusablePaymentsCountLimit") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-if="!store.getters.getAppData?.requisitesReusablePaymentsCountLimitEnabled" v-slot="parentProps" field="reusablePaymentsCountLimit" form="requisitesForm">
              <input v-model="form.reusablePaymentsCountLimit"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" required class="form-control " id="reusablePaymentsCountLimit">
            </FormInputWrapper>
            <input v-else
                   :value="store.getters.getAppData?.requisitesReusablePaymentsCountLimit ?? 11"
                   disabled
                   type="text"
                   class="form-control"
                   id="reusablePaymentsCountLimit">
          </div>
        </div>

        <div class="row mt-4">
          <label for="isFarmsSettingsEnabled" class="col-sm-3 col-form-label  text-capitalize-first">
            {{ helper.trans('labels.farmsSettings') }}
          </label>
          <div class="col-sm-3 form-check form-switch d-flex align-items-center">
            <input v-model="form.isFarmsSettingsEnabled" id="isFarmsSettingsEnabled" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch"  >
          </div>
        </div>

        <div class="row mt-2" v-if="form.isFarmsSettingsEnabled">
          <label for="concurrentTradesCount" class="col-sm-3 col-form-label text-capitalize-first pe-2 text-end">{{ helper.trans("labels.concurrent_trader_count") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="concurrentTradesCount" form="requisitesForm">
              <input v-model="form.concurrentTradesCount"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" class="form-control " id="concurrentTradesCount">
            </FormInputWrapper>
          </div>

          <label for="tradesTimeoutMinutes" class="col-sm-3 col-form-label text-capitalize-first pe-2 text-end">{{ helper.trans("labels.trades_timeout_minutes") }}</label>
          <div class="col-sm-3">
            <FormInputWrapper v-slot="parentProps" field="tradesTimeoutMinutes" form="requisitesForm">
              <input v-model="form.tradesTimeoutMinutes"
                     v-maska
                     :class="parentProps.class"
                     data-maska="9 99#"
                     data-maska-tokens="9:[0-9]:repeated"
                     data-maska-reversed
                     type="text" class="form-control " id="tradesTimeoutMinutes">
            </FormInputWrapper>
          </div>
        </div>

        <div v-if="form.method && blacklistMethods.includes(form.method)" class="row mt-4">
          <div class="col-sm-12">
            <FormInputWrapper v-slot="parentProps" field="isAgreeBlacklistPaymentMethod" form="requisitesForm">
            <div class="alert alert-danger mb-0" :class="parentProps.class" role="alert">
              <div class="form-check small mb-0">
                  <input class="form-check-input" v-model="form.isAgreeBlacklistPaymentMethod" type="checkbox" value="" id="isAgreeBlacklistPaymentMethod">
                  <label class="form-check-label" for="isAgreeBlacklistPaymentMethod">
                    {{ helper.trans('labels.agree_with_risk')}}
                  </label>
              </div>
            </div>
            </FormInputWrapper>
          </div>
        </div>

      </div>
    </div>

  </form>
</template>

<script lang="ts">
import {computed, defineComponent, reactive, toRefs, watch} from "vue";
import Multiselect from "vue-multiselect";
import RequisitesFormDTO, {AdditionalField, getAdditionalFields} from "@/models/form/RequisitesFormDTO";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import {PaymentOption} from "@/models/enum/PaymentOption";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import {PaymentMethod} from "@/models/enum/PaymentMethod";
import DropzoneInput from "@/apps/public/components/DropzoneInput.vue";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import {clearPixRawFields, clearQrisRawFields, normalizeVietQrRaw, pixEmvFromRaw, qrisEmvFromRaw, readFileAsDataUrl, readQrStringFromImageFile} from "@/service/vietQrRawHelpers";
import {crossBorderSwift} from "@/service/crossBorderSwift";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import {useDropzone} from "vue3-dropzone";
import DevicesMultiselect from "@/components/DevicesMultiselect.vue";
import {api} from "@/service/APIClient";

const components = {
  Multiselect,
  TraderMultiselect,
  DevicesMultiselect,
  FormInputWrapper,
  PayMethodIcon,
  DropzoneInput
}

interface AttachmentFileDTO {
  id: number;
  file: File,
}

let id = 1;

export default defineComponent({
  name: "RequisitesForm",
  components,
  setup() {
    const store = useStore();
    const state = reactive({
      fileAttachment: null as AttachmentFileDTO|null,
      isImport: false,
      form: {} as RequisitesFormDTO,
      blacklistMethods: [] as string[]
    });


    const onDrop = async (acceptFiles: any, rejectReasons: any) => {
      for (const file of acceptFiles) {
        state.fileAttachment = {
          id: id++,
          file,
        } as AttachmentFileDTO
        state.form.file = await api.attachmentsUpload(file)
        break;
      }
    }
    const dropzone = useDropzone({ onDrop, accept:['.xlsx'], multiple: false, maxFiles: 1 });

    const getForm = (): RequisitesFormDTO => {
      return state.form
    }

    const setForm = (form: RequisitesFormDTO, blacklistMethods: string[] = [], isImport: boolean = false) => {
      let raw = form.raw && typeof form.raw === "object" ? {...form.raw} : {}
      if (form.paymentOption === PaymentOption.VIET_QR) {
        raw = normalizeVietQrRaw(raw) as Record<string, unknown>
      }
      if (form.paymentOption === PaymentOption.IND_QR) {
        const emv = qrisEmvFromRaw(raw)
        if (emv) {
          raw.qrString = emv
        }
      }
      if (form.paymentOption === PaymentOption.BR_QR) {
        const emv = pixEmvFromRaw(raw)
        if (emv) {
          raw.qrString = emv
        }
      }
      state.form = {
        ...form,
        raw,
        p2cConfig: form.p2cConfig && typeof form.p2cConfig === "object" ? {...form.p2cConfig} : {},
        qrisIsStatic: form.qrisIsStatic ?? false,
        pixIsStatic: form.pixIsStatic ?? false,
      }
      state.isImport = isImport
      state.blacklistMethods = blacklistMethods
    }

    const onVietQrImageChange = async (files: File[]) => {
      helper.clearErrors('requisitesForm')
      if (files.length !== 1) {
        return
      }
      const file = files[0]
      try {
        const qrString = await readQrStringFromImageFile(file)
        if (!qrString) {
          helper.setErrors('requisitesForm', [{
            code: "",
            field: "raw_field_qrImage",
            message: helper.trans(state.form.paymentOption === PaymentOption.IND_QR ? 'labels.qris_image_unreadable' : state.form.paymentOption === PaymentOption.BR_QR ? 'labels.pix_image_unreadable' : 'labels.qr_upload_file_error'),
          } as ValidationErrorDTO])
          return
        }
        if (!state.form.raw) {
          state.form.raw = {}
        }
        state.form.raw.qrString = qrString
        state.form.raw.qrImage = await readFileAsDataUrl(file)
      } catch {
        helper.setErrors('requisitesForm', [{
          code: "",
          field: "raw_field_qrImage",
          message: helper.trans(state.form.paymentOption === PaymentOption.IND_QR ? 'labels.qris_image_unreadable' : state.form.paymentOption === PaymentOption.BR_QR ? 'labels.pix_image_unreadable' : 'labels.qr_upload_file_error'),
        } as ValidationErrorDTO])
      }
    }

    const rawFields = computed<AdditionalField[]>(() => {
      if (state.form.paymentOption === PaymentOption.VIET_QR || state.form.paymentOption === PaymentOption.IND_QR || state.form.paymentOption === PaymentOption.BR_QR) {
        return [
          {name: 'qrString', type: 'textarea'},
          {
            name: 'qrImage',
            type: 'dropzone',
            label: "labels.qr_upload_file",
            dropzone: {onChange: onVietQrImageChange},
          },
        ]
      }
      return []
    })

    watch(() => state.form.paymentOption, (next, prev) => {
      if (next === PaymentOption.VIET_QR || next === PaymentOption.IND_QR || next === PaymentOption.BR_QR || next === PaymentOption.CROSS_BORDER) {
        if (!state.form.raw || typeof state.form.raw !== 'object') {
          state.form.raw = {}
        }
      }
      if (next === PaymentOption.IND_QR) {
        state.form.qrisIsStatic = state.form.qrisIsStatic ?? false
        state.form.requisites = ''
      }
      if (next === PaymentOption.BR_QR) {
        state.form.pixIsStatic = state.form.pixIsStatic ?? false
        state.form.requisites = ''
      }
      if (next === PaymentOption.MANUAL_SBP_QR) {
        state.form.requisites = ''
      }
      if (prev === PaymentOption.VIET_QR && next !== PaymentOption.VIET_QR && state.form.raw) {
        delete state.form.raw.qrString
        delete state.form.raw.qrImage
        delete state.form.raw.vietQrTemplate
      }
      if (prev === PaymentOption.IND_QR && next !== PaymentOption.IND_QR && state.form.raw) {
        clearQrisRawFields(state.form.raw)
        state.form.qrisIsStatic = false
      }
      if (prev === PaymentOption.BR_QR && next !== PaymentOption.BR_QR && state.form.raw) {
        clearPixRawFields(state.form.raw)
        state.form.pixIsStatic = false
      }
      if (prev === PaymentOption.CROSS_BORDER && next !== PaymentOption.CROSS_BORDER && state.form.raw && typeof state.form.raw === 'object') {
        delete state.form.raw.swift
      }
    })

    const isHolderNameVisible = computed(() => {
        return state.form.paymentOption !== PaymentOption.P2C
    })

    const requisiteFieldLabel = computed(() => {
      if (state.form.paymentOption === PaymentOption.P2C) {
        switch (state.form.method) {
          case PaymentMethod.bkash_bdt:
            return helper.trans('labels.additional_field.username');
        }
      }

      return helper.trans('labels.requisites')
    })

    const isAccountNumberVisible = computed(() => {
      if (!state.form.paymentOption) {
        return false;
      }

      return ([PaymentOption.SBP, PaymentOption.TO_PHONE_NUMBER, PaymentOption.SBP_QR, PaymentOption.CLICK_UZ_QR, PaymentOption.TO_CARD] as PaymentOption[]).includes(state.form.paymentOption as PaymentOption)
    })

    const additionalFields = computed<AdditionalField[]>(() => {
      return getAdditionalFields(state.form)
    })


    const requisitesMaskaPlaceholder = computed(() => {
      if (state.form.paymentOption === PaymentOption.SBP_QR && state.form.method === PaymentMethod.qr_manager) {
        return helper.trans(`payment_options_requisites.SBP_QR_qr_manager`, {}, '');
      }

      if (state.form.paymentOption === PaymentOption.SBP_QR && state.form.method === PaymentMethod.vasl) {
        return helper.trans(`payment_options_requisites.phone_number`, {}, '');
      }

      const option = helper.trans(`payment_options_requisites.${state.form.paymentOption}`, {}, '');

      return helper.trans(`payment_options_requisites.${state.form.paymentOption}_${state.form.method}`, {}, option);
    })

    const paymentOptionCurrency = computed((): string|null => {
      if (state.form.currency === null) {
        return null;
      }

      return ([PaymentOption.CROSS_BORDER, PaymentOption.MOBILE_TOP_UP] as PaymentOption[]).includes(state.form.paymentOption as PaymentOption) ? state.form.crossBorderCurrency : state.form.currency
    })

    const traderForLimits = computed(() => (state.form as any)?.trader ?? store.getters.getUser);

    const isMinSumFieldDisabledByTraderLimit = computed(() => {
      const trader = traderForLimits.value as any;
      const currency = paymentOptionCurrency.value;
      const minPayInDealSum = state.form.minPayInDealSum;
      
      if (!trader?.requisitesLimits?.length || !currency || !minPayInDealSum) {
        return false;
      }

      const traderLimit = trader.requisitesLimits.find((limit: { currency: string }) => 
        limit.currency === currency
      );
      
      if (!traderLimit) {
        return false;
      }

      const traderLimitAmount = Number.parseInt(traderLimit.amountLimitForDeal.replace(/\s/g, ''));
      const currentAmount = Number.parseInt(minPayInDealSum.replace(/\s/g, ''));
      
      return currentAmount > traderLimitAmount;
    });

    const requisitesMaskaOptions = computed(() => {
      if (state.form.paymentOption === PaymentOption.VIET_QR || state.form.paymentOption === PaymentOption.IND_QR || state.form.paymentOption === PaymentOption.BR_QR) {
        return {pattern: null, tokens: null}
      }
      if (state.form.paymentOption === PaymentOption.CROSS_BORDER && crossBorderSwift(state.form.raw)) {
        return {
          pattern: '9',
          tokens: '9:[0-9]:repeated'
        }
      }
      if (!state.form.method || !state.form.requisites) {
        return {
          pattern: null,
          tokens: null
        }
      }

      if (state.form.paymentOption === PaymentOption.SBP_QR || state.form.paymentOption === PaymentOption.CLICK_UZ_QR || state.form.paymentOption === PaymentOption.P2C || state.form.paymentOption === PaymentOption.TIPS || state.form.paymentOption === PaymentOption.IBAN || state.form.paymentOption === PaymentOption.PEN_QR) {
        return {
          pattern: null,
          tokens: null
        }
      }

      if (state.form.paymentOption === PaymentOption.TO_ACCOUNT) {
        return {
          pattern: '9',
          tokens: '9:[0-9]:repeated'
        }
      }

      if (state.form.paymentOption === PaymentOption.CVU) {
        return {
          pattern: '######################',
          tokens: '9:[0-9]:repeated'
        }
      }

      if (state.form.paymentOption === PaymentOption.SBP || state.form.paymentOption === PaymentOption.TO_PHONE_NUMBER || state.form.requisites && state.form.requisites.startsWith('+')) {
        return {pattern: helper.getPhonePattern(state.form.requisites), tokens: '9:[0-9]:repeated'};
      }

      return {
        pattern: '#### #### #### ####',
        tokens: '9:[0-9]:repeated'
      }
    })

    const parseHttpHeaders = (raw: string): {
      deviceid?: string;
      passwordhash?: string;
      hashcode?: string;
    } => {
      const result: Record<string, string | undefined> = {};

      const regex = /^(deviceid|passwordhash|hashcode):\s*(.+)$/gim;
      let match: RegExpExecArray | null;

      while ((match = regex.exec(raw)) !== null) {
        const key = match[1].toLowerCase();
        const value = match[2].trim();
        result[key] = value;
      }

      return {
        deviceid: result['deviceid'],
        passwordhash: result['passwordhash'],
        hashcode: result['hashcode'],
      };
    }

    watch(() => state.form.p2cConfig?.http_request, (value) => {
      if (value) {
        const data = parseHttpHeaders(value);
        state.form.p2cConfig['device_id'] = data.deviceid
        state.form.p2cConfig['hashcode'] = data.hashcode
        state.form.p2cConfig['passwordhash'] = data.passwordhash
      }
    })

    const isTrader = computed(() => store.getters.isTrader)
    const isTraderOperator = computed(() => store.getters.isTraderOperator)
    const isAdmin = computed(() => store.getters.isAdmin)

    return {
      ...toRefs(state),
      getForm,
      setForm,
      store,
      helper,
      requisitesMaskaOptions,
      requisitesMaskaPlaceholder,
      paymentOptionCurrency,
      isAccountNumberVisible,
      isHolderNameVisible,
      additionalFields,
      rawFields,
      PaymentOption,
      PaymentMethod,
      requisiteFieldLabel,
      isMinSumFieldDisabledByTraderLimit,
      isTrader,
      isTraderOperator,
      isAdmin,
      dropzone
    }
  },
  async beforeMount() {
    const store = useStore();
    await store.dispatch("currencyMethods/loadList");
    await store.dispatch("devices/loadList");
    await store.dispatch("reqGroups/loadList");
  }
})
</script>
